export default {
    create_unsubscribed_contact_title: "New Unsubscribed Contact",
    create_unsubscribed_contact_has_been_created: "The unsubscribed contact has been created",
    create_unsubscribed_contact_via: "Via:",
    create_unsubscribed_contact_country_code: "Country Code",
    create_unsubscribed_contact_email: "Email",
    create_unsubscribed_contact_phone_number: "Phone Number",
    create_unsubscribed_contact_error_create: "Unable to create the unsubscribed contact due to an error",
    create_unsubscribed_contact_via_email: "Email",
    create_unsubscribed_contact_via_sms: "SMS",
    create_unsubscribed_contact_email_is_invalid: "Invalid email",
    create_unsubscribed_contact_reason: "Reason",
    create_unsubscribed_contact_required_phone: "Please enter a valid phone number",
}